import { render, staticRenderFns } from "./integral-records.vue?vue&type=template&id=04e0f9da&scoped=true"
import script from "./integral-records.vue?vue&type=script&lang=js"
export * from "./integral-records.vue?vue&type=script&lang=js"
import style0 from "./integral-records.vue?vue&type=style&index=0&id=04e0f9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e0f9da",
  null
  
)

export default component.exports